import { Button, Form, Input, message } from "antd";
import { useForm } from "antd/es/form/Form";
import { RenderCrudTitle } from "app/components/CustomFC";
import HAModal from "app/components/HAModal";
import { FORM_MODE } from "constant";
import { useHandleSubmitApi, useSetValue } from "hook";
import { IGetCatePostOutputModel } from "interfaces";
import React, { useEffect } from "react";
import { PostServices } from "services";
import "./CatePostModal.style.scss";

export interface ICatePostModalPresenterProps {
  catePost: IGetCatePostOutputModel | null;
  onConfirm: () => void;
  onClose: () => void;
  mode: FORM_MODE;
}

interface IStateCatePostForm {
  name: string;
}

export default function CatePostModalPresenter(props: ICatePostModalPresenterProps) {
  const [form] = useForm();

  const initalValues: IStateCatePostForm = {
    name: "",
  };

  const [formValues, setFormValues, removeFormValues] = useSetValue<IStateCatePostForm>(initalValues);

  useEffect(() => {
    if (props.catePost) bindDetail(props.catePost);

    return () => {
      removeFormValues(initalValues);
      form.setFieldsValue(initalValues);
    };

    // eslint-disable-next-line
  }, [props.catePost]);

  const bindDetail = (catePost: IGetCatePostOutputModel) => {
    const data: IStateCatePostForm = {
      name: catePost.name,
    };

    form.setFieldsValue(data);
    setFormValues(data);
  };

  const handleClose = () => {
    props.onClose();
  };

  const [handleSubmitApi, loading] = useHandleSubmitApi(async (data: IStateCatePostForm) => {
    if (props.mode === FORM_MODE.EDIT) {
      if (!props.catePost) return message.success("Có lỗi xảy ra");

      const dataRes = await PostServices.updateCatePost({ ...data, catePostId: props.catePost.id });
      if (dataRes) {
        message.success("Cập nhật danh mục thành công!");
        props.onConfirm();
      }
    } else {
      const dataRes = await PostServices.createCatePost({ ...data });
      if (dataRes) {
        message.success("Tạo danh mục thành công!");
        props.onConfirm();
      }
    }
  });

  return (
    <HAModal
      width={480}
      height={560}
      onClose={handleClose}
      visible={true}
      title={<RenderCrudTitle mode={props.mode} title={"danh mục"} />}
      actions={
        <>
          <Button className="btn btn-outline" size="large" onClick={handleClose}>
            Huỷ bỏ
          </Button>
          <Button
            className="btn"
            size="large"
            loading={loading}
            onClick={() => form.validateFields().then(handleSubmitApi)}
          >
            Xác nhận
          </Button>
        </>
      }
    >
      {() => {
        return (
          <React.Fragment>
            <Form
              form={form}
              className="w_100"
              initialValues={formValues || initalValues}
              onValuesChange={(values) => console.log(values)}
            >
              <div className="cate-service-modal">
                <div className="cate-service-modal__item">
                  <div className="cate-service-modal__item-label required">{"Tên danh mục"}</div>
                  <Form.Item
                    name="name"
                    rules={[
                      {
                        required: true,
                        message: "Vui lòng nhập tên danh mục!",
                      },
                    ]}
                  >
                    <Input size="large" placeholder="Nhập tên danh mục" />
                  </Form.Item>
                </div>
              </div>
            </Form>
          </React.Fragment>
        );
      }}
    </HAModal>
  );
}
